import { useCallback, useState } from 'react';

import * as S from './styles';
import { Message, toaster } from 'rsuite';
import { Label } from '../../../../components/Label';
import { CustomInput } from '../../../../components/CustomInput';
import { CustomInputNumber } from '../../../../components/CustomInputNumber';
import { CustomButton } from '../../../../components/CustomButton';
import { useAuth } from '../../../../hooks/auth';
import api from '../../../../services/api';

const initialAddTamanho = {
  descricao: '',
  qtdSabores: 1,
  qtdPedacos: 2,
};

export const CreateSize = ({ setSizes }) => {
  const [addTamanho, setAddTamanho] = useState(initialAddTamanho);
  const [isOpen, setIsOpen] = useState(false);
  const { id_empresa } = useAuth();

  function handleAddTamanho() {
    if (
      !addTamanho.descricao ||
      !addTamanho.qtdSabores ||
      !addTamanho.qtdPedacos
    ) {
      toaster.push(
        <Message showIcon type="error">
          Preencha todos os campos
        </Message>,
      );
      return;
    }

    handleCreateSubmit();
  }

  const handleCreateSubmit = useCallback(async () => {
    await api
      .post('tamanho/criar', {
        IdEmpresa: id_empresa,
        TipoPizza: true,
        QtdSabores: Number(addTamanho?.qtdSabores),
        QtdPedacos: Number(addTamanho?.qtdPedacos),
        Descricao: addTamanho?.descricao,
      })
      .then((res) => {
        setSizes((sizes) => [...sizes, res.data]);
        setAddTamanho(initialAddTamanho);
        setIsOpen(false);
        toaster.push(
          <Message showIcon type="success">
            Tamanho cadastrado
          </Message>,
        );
      })
      .catch((error) => console.log(error));
  }, [addTamanho, setSizes, id_empresa]);

  return (
    <S.CreateCard>
      <S.CreateCardHeader>
        <S.CreateCardTitle>Novo Tamanho</S.CreateCardTitle>
        <CustomButton
          appearance={isOpen ? 'default' : 'primary'}
          size="sm"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          {isOpen ? 'Fechar' : '+ Adicionar'}
        </CustomButton>
      </S.CreateCardHeader>

      {isOpen && (
        <S.CreateCardBody>
          <S.FieldsRow>
            <S.StyledCol xs={24} sm={12}>
              <Label>Nome do tamanho</Label>
              <CustomInput
                placeholder="ex: Pequena, Grande, Família..."
                value={addTamanho?.descricao}
                onChange={(e) =>
                  setAddTamanho((prev) => ({ ...prev, descricao: e }))
                }
              />
            </S.StyledCol>
            <S.StyledCol xs={12} sm={6}>
              <Label>Qtd. Sabores</Label>
              <CustomInputNumber
                value={addTamanho?.qtdSabores}
                min={1}
                onChange={(e) =>
                  setAddTamanho((prev) => ({ ...prev, qtdSabores: e }))
                }
              />
            </S.StyledCol>
            <S.StyledCol xs={12} sm={6}>
              <Label>Qtd. Pedaços</Label>
              <CustomInputNumber
                value={addTamanho?.qtdPedacos}
                min={1}
                onChange={(e) =>
                  setAddTamanho((prev) => ({ ...prev, qtdPedacos: e }))
                }
              />
            </S.StyledCol>
          </S.FieldsRow>
          <S.CreateActions>
            <CustomButton appearance="primary" onClick={handleAddTamanho}>
              Cadastrar Tamanho
            </CustomButton>
          </S.CreateActions>
        </S.CreateCardBody>
      )}
    </S.CreateCard>
  );
};
